import React from 'react';

export const KIDPLACE_SEGMENTS = [
  { value: 'municipal', label: 'Przedszkola publiczne' },
  { value: 'public_private', label: 'Publiczno-prywatne' },
  { value: 'private', label: 'Przedszkola prywatne' },
  { value: 'nursery_public', label: 'Żłobki publiczne' },
  { value: 'nursery_private', label: 'Żłobki prywatne' },
  { value: 'maluch_public', label: 'MALUCH+ publiczne' },
  { value: 'maluch_private', label: 'MALUCH+ prywatne' },
];

export default function MarketTypeFilter({ selected, onChange }) {
  const selectedSet = new Set(selected || []);
  const allSelected = KIDPLACE_SEGMENTS.every((item) => selectedSet.has(item.value));

  function toggle(value) {
    if (selectedSet.has(value)) {
      if (selectedSet.size <= 1) return;
      onChange((selected || []).filter((item) => item !== value));
      return;
    }
    onChange([...selectedSet, value]);
  }

  return (
    <div className="prospecting-type-filter" role="group" aria-label="Filtr typów placówek Kidplace">
      <span className="prospecting-type-filter-label">Typ placówki</span>
      <button type="button" className={allSelected ? 'is-active' : ''} onClick={() => onChange(KIDPLACE_SEGMENTS.map((item) => item.value))}>
        Wszystkie
      </button>
      {KIDPLACE_SEGMENTS.map((item) => {
        const active = selectedSet.has(item.value);
        return (
          <button type="button" key={item.value} className={active ? 'is-active' : ''} aria-pressed={active} onClick={() => toggle(item.value)}>
            <span className="prospecting-type-filter-check" aria-hidden="true">{active ? '✓' : ''}</span>
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
